import { Component } from '@angular/core';

import { DxScrollViewComponent } from 'devextreme-angular/ui/scroll-view';

@Component({
  selector: 'app-login-card',
  templateUrl: './login-card.component.html',
  styleUrls: ['./login-card.component.scss'],
  imports: [DxScrollViewComponent],
  standalone: true,
})
export class LoginCardComponent {

}

